import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Report, ReportState } from '../types/report';

const initialState: ReportState = {
  cumulative: null,
  reports: [],
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    fetchReportsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchReportsSuccess: (state, action: PayloadAction<Report[]>) => {
      state.loading = false;
      state.reports = action.payload;
    },
    fetchReportsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchReportsStart,
  fetchReportsSuccess,
  fetchReportsFailure,
} = reportSlice.actions;

export default reportSlice.reducer;